export default __webpack_public_path__ + "static/media/Rectangle 5555 (1).2850eb47.png";